import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'

/**
 * Get Public purchase orders by Seller.
 */
export const getPublicPurchaseOrdersBySeller = factoryService(({ dni, filters, token }) => {
  const field = filters.sort ? `&field=${filters.field}&sort=${filters.sort}` : ''
  const page = `offset=${filters.offset}&pageSize=${filters.pageSize}`
  const tokenReCaptcha = `&tokenReCaptcha=${token}`

  return getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/proveedor-unico/publico/filtro?rut=${normalizeDniSlashes(dni)}&${page}${field}${tokenReCaptcha}`
  )
})

/**
 * Get purchase orders by Seller.
 */
export const getPurchaseOrdersBySeller = factoryService(({ dni, filters }) => {
  const field = filters.sort ? `&field=${filters.field}&sort=${filters.sort}` : ''
  const page = `offset=${filters.offset}&pageSize=${filters.pageSize}`

  return getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/proveedor-unico/filtro?rut=${normalizeDniSlashes(dni)}&${page}${field}`
  )
})
